module.exports = __webpack_public_path__ + "img/pdfBg.ae7c2b8e.png";